import { Component, OnInit } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/UserService'

const exampleHtml = `
<se-po-persona-avatar
  [persona]="persona">
</se-po-persona-avatar>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/UserService'
export class PersonaAvatarExampleComponent implements OnInit {
  public persona: Persona
  public ngOnInit(): void {
    this.persona = {
      id: 5,
      date_of_birth: '2009-12-31',
      first_name:'Junior',
      gender: 'male',
      last_name: 'Test',
      profile_images: [
        {
          image_type: 'crop',
          url: 'https://images.nbcolympics.com/sites/default/files/post/short_form_video/oly22_st_SMD_bineymini__635693.jpg'
        }
      ]
    } as Persona
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-avatar-example',
  template,
  styleUrls: ['./../persona-avatar-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public persona: Persona

  public ngOnInit(): void {
    this.persona = {
      id: 5,
      date_of_birth: '2009-12-31',
      first_name:'Junior',
      gender: 'male',
      last_name: 'Test',
      profile_images: [
        {
          image_type: 'crop',
          url: 'https://images.nbcolympics.com/sites/default/files/post/short_form_video/oly22_st_SMD_bineymini__635693.jpg'
        }
      ]
    } as Persona
  }
}
